import React from 'react'

import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import NotFound from "../../not-found/not-found"

type Props = {
    notFoundMessage     : string
}

// const debug = "SelectParent_ProjectsNotFound"
const debug = false

export default function SelectParent_ProjectsNotFound(props: Props) {
    return (
        <div className="flex-column-right-top w-100-percent h-100-percent">
            <VScroll className="h-100-percent p-b-10">
                <NotFound message={props.notFoundMessage} />
            </VScroll>
        </div>
    )
}
